import { AbstractImageDrawableItem } from "./AbstractImageDrawableItem";
import { TypeKeys } from "./TypeKeys";
import { PaintStyle } from "../../../domain/drawing/PaintStyle";
import { IPaintableOnEditing } from "./IPaintableOnEditing";
import { IExternalScriptImageAssociatable } from "./IExternalScriptImageAssociatable";
import { ScriptLinkItem } from "../../localhost/items/ScriptLinkItem";
import { ImageSourceKinds } from "../ImageSourceKinds";
import { ImageKinds } from "../ImageKinds";
import { IRelatedExternalScriptExecutable } from "./IRelatedExternalScriptExecutable";
import { IItem } from "./IItem";
import { RelationalActionParameter } from "./RelationalActionParameter";

export class ImageItem extends AbstractImageDrawableItem implements IPaintableOnEditing, IExternalScriptImageAssociatable, IRelatedExternalScriptExecutable {
  constructor(typeKey: string = TypeKeys.ImageItem) {
    super(typeKey);
  }

  public name: string = null;
  public paintStyle: PaintStyle = new PaintStyle();
  public paintStyleOnEditing: PaintStyle = null;
  public scriptExecuteParameters: RelationalActionParameter[] = [];
 
  protected createCloneInstance(): ImageItem {
    return new ImageItem();
  }

  protected applyMembers(clone: ImageItem): void {
    super.applyMembers(clone);
    clone.name = this.cloneValue(this.name);
    clone.paintStyle = this.cloneValue(this.paintStyle);
    clone.paintStyleOnEditing = this.cloneValue(this.paintStyleOnEditing);
    clone.scriptExecuteParameters = this.cloneValue(this.scriptExecuteParameters);
  }

  updateImageByExternalScript(info: ScriptLinkItem, departmentId: string): void {
    this.clearImageInformation();
    if (!info.cacheImageGuid) { return; }
    
    if (info.claioImageId) {
      this.claioImageId = info.claioImageId;
      this.imageDepartmentId = departmentId;
      this.imageKind = ImageKinds.ClaioImage;
    } else {
      this.imageKind = ImageKinds.Image;
    }
    this.imageSource.imageGuid = info.cacheImageGuid;
    this.imageSource.imageSourceKind = ImageSourceKinds.Cache;
    this.originalImageSource.imageGuid = info.cacheImageGuid;
    this.originalImageSource.imageSourceKind = ImageSourceKinds.Cache;
    this.drawLayerImageSource.imageGuid = null;
    this.drawLayerImageSource.imageSourceKind = ImageSourceKinds.None;
    this.drawObjectData = null;
    this.rotationAngle = 0;
  }

  isValueUpdated(oldItem: IItem): boolean {
    // TODO: implement
    return true;
  }
}
